import PropTypes from 'prop-types';
import React from 'react';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import { Box, Button } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Message from './Message';

const icon = <CheckCircle />;

const SuccessMessage = props => {
  const { backButtonLabel, children, continueButtonLabel, onBack, onContinue, outlined, title, gutterBottom } = props;
  const showBackButton = typeof onBack === 'function';
  const showContinueButton = typeof onContinue === 'function';
  return (
    <Message
      color="success.main"
      titleColor="textPrimary"
      icon={icon}
      outlined={outlined}
      title={title}
      gutterBottom={gutterBottom}
    >
      <>
        <Box>
          {children}
        </Box>
        {
          (showBackButton || showContinueButton) && (
            <Box mt={2} display="flex" flexDirection="row-reverse">
              <Box>
                {
                  showContinueButton && (
                    <Button variant="contained" onClick={onContinue}>
                      { !!continueButtonLabel && continueButtonLabel }
                      { !continueButtonLabel && <FormattedTranslation id="general.button.continue" /> }
                    </Button>
                  )
                }
              </Box>
              <Box mx={1}>
                {
                  showBackButton && (
                    <Button variant="contained" onClick={onBack}>
                      { !!backButtonLabel && backButtonLabel }
                      { !backButtonLabel && <FormattedTranslation id="general.button.back" /> }
                    </Button>
                  )
                }
              </Box>
            </Box>
          )
        }
      </>
    </Message>
  );
};

SuccessMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  backButtonLabel: PropTypes.string,
  continueButtonLabel: PropTypes.string,
  onBack: PropTypes.func,
  onContinue: PropTypes.func,
  outlined: PropTypes.bool,
  title: PropTypes.string,
  gutterBottom: PropTypes.bool,
};

SuccessMessage.defaultProps = {
  backButtonLabel: '',
  continueButtonLabel: '',
  outlined: true,
  gutterBottom: false,
};

export default SuccessMessage;
